<template>
  <b-container v-if="auth == 'loggedin' || token != null || token != undefined">
    <b-card
      class="text-center mt-2"
      header="Megmunkálás szerkesztése"
      border-variant="primary"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <b-card-body class="text-left">
        <b-form @submit="addElement">
          <div class="form-group">
            <label for="megnevezes">Megnevezés</label>
            <b-form-input
              size="sm"
              type="text"
              v-model="list.megnevezes"
              id="megnevezes"
              required
            />
          </div>

          <div class="form-group">
            <label for="ar_fm">Ft/fm (nettó)</label>
            <b-form-input
              size="sm"
              type="number"
              v-model="list.ar_fm"
              id="ar_fm"
              required
            />
          </div>

          <b-button variant="primary" type="submit">
            <b-icon-cloud-upload></b-icon-cloud-upload>
            Mentés
          </b-button>

          <b-button
            variant="outline-danger"
            class="float-right"
            @click="$router.push({ name: 'Megmunkalasok' })"
          ><b-icon-arrow-left></b-icon-arrow-left>
            Mégsem
          </b-button>
        </b-form>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import axios from 'axios'
import router from '../router'
import jwtDecode from 'jwt-decode'

export default {
  data: () => {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      list: {}
    }
  },
  methods: {
    addElement: function () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.id = this.list.id
        payload.megnevezes = this.list.megnevezes
        payload.ar_fm = this.list.ar_fm
        payload.hidden = 1
        payload.token = this.token
        payload.userType = this.userType
        axios.post('https://' + process.env.ROOT_API + '/megmunkalasok/save', { payload })
          .then(() => { this.$router.push({ name: 'Megmunkalasok' }) })
          .catch(err => { console.log(err) })
      }
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    let payload = {}
    if (!this.token) {
      router.push({ name: 'Login' })
    } else {
      payload.id = id
      payload.token = this.token
      payload.userType = this.userType
      if (id) {
        axios.post('https://' + process.env.ROOT_API + '/megmunkalasok/edit', { payload })
          .then(res => { this.list = res.data })
          .catch(err => { console.log(err) })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MegmunkalasokNew.vue